import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementWellCreateMutation, useMeasurementWellDeleteMutation, useMeasurementWellUpdateMutation, useMeasurementWellFindAllQuery } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useMeasurementWellFindAllQuery(`?well_id=${id}`);
  const [measurementWellCreate, measurementWellCreateResult] = useMeasurementWellCreateMutation();
  const [measurementWellUpdate, measurementWellUpdateResult] = useMeasurementWellUpdateMutation();
  const [measurementWellDelete, measurementWellDeleteResult] = useMeasurementWellDeleteMutation();

  const [measurementWell, setMeasurementWell] = useState<any>();

  const [contains_water, setContains_waterBoolean] = useState<boolean>(false);
  const [is_used, setIs_usedBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleandBoolean] = useState<boolean>(false);


  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: qualityData,
    error: qualityDataError,
    isFetching: isQualityDataFetching,
  } = useCommonDataFindAllQuery(`?group_name=water_hydraulic_quality`);

  useEffect(() => {

    if (measurementWell === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.water_level_decrease);

    const tempContains_water = measurementWell !== null ? measurementWell?.contains_water : false;
    const tempIs_used = measurementWell !== null ? measurementWell?.is_used : false;
    const tempIs_clean = measurementWell !== null ? measurementWell?.is_clean : false;

    setContains_waterBoolean(tempContains_water)
    setIs_usedBoolean(tempIs_used)
    setIs_cleandBoolean(tempIs_clean)

  }, [measurementWell, qualityData, id, data?.data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementWell?.id,
      well_id: measurementWell?.well_id,
      well_code: measurementWell?.well_code,
      measure_date: measurementWell?.measure_date,
      depth: measurementWell?.depth,
      water_spurt: measurementWell?.water_spurt,
      water_level_decrease: measurementWell?.water_level_decrease,
      water_stable_level: measurementWell?.water_stable_level,
      water_hydraulic_quality: measurementWell?.water_hydraulic_quality,
      refrain: measurementWell?.refrain,
      well_counter_detail: measurementWell?.well_counter_detail,
      equipment: measurementWell?.equipment,
      enclosure: measurementWell?.enclosure,
      usage_information: measurementWell?.usage_information,
      sanitary_requirements: measurementWell?.sanitary_requirements,
      day_avg_using: measurementWell?.day_avg_using,
      is_counter: measurementWell?.is_counter,
      report_autor: measurementWell?.report_autor,
      report_code: measurementWell?.report_code,
      report_name: measurementWell?.report_name,
    },
    validationSchema: Yup.object({
      well_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      depth: Yup.string().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_spurt: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("утга оруулна уу !"),
      water_level_decrease: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_hydraulic_quality: Yup.number().typeError("Тоон сонгоно уу").required("Утга оруулна уу !"),
      water_stable_level: Yup.string().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      refrain: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      well_counter_detail: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      equipment: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      enclosure: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      day_avg_using: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (measurementWell !== null) {
        const updateList = {
          id: measurementWell?.id,
          well_id: measurementWell?.well_id,
          well_code: values.well_code,
          measure_date: values.measure_date,
          depth: values.depth,
          water_spurt: values.water_spurt,
          water_level_decrease: values.water_level_decrease,
          water_hydraulic_quality: values.water_hydraulic_quality,
          water_stable_level: values.water_stable_level,
          refrain: values.refrain,
          well_counter_detail: values.well_counter_detail,
          report_autor: values.report_autor,
          report_code: values.report_code,
          report_name: values.report_name,
          equipment: values.equipment,
          enclosure: values.enclosure,
          usage_information: values.usage_information,
          sanitary_requirements: values.sanitary_requirements,
          day_avg_using: values.day_avg_using,

          is_counter: values.is_counter,
          contains_water: contains_water === undefined ? false : contains_water,
          is_used: is_used === undefined ? false : is_used,
          is_clean: is_clean === undefined ? false : is_clean,
        }
        measurementWellUpdate(updateList);
      } else {
        const newList = {
          well_id: id,
          well_code: values["well_code"],
          measure_date: values["measure_date"],
          depth: values["depth"],
          water_spurt: values["water_spurt"],
          water_level_decrease: values["water_level_decrease"],
          water_hydraulic_quality: values["water_hydraulic_quality"],
          water_stable_level: values["water_stable_level"],
          refrain: values["refrain"],
          well_counter_detail: values["well_counter_detail"],
          report_autor: values["report_autor"],
          report_code: values["report_code"],
          report_name: values["report_name"],
          equipment: values["equipment"],
          enclosure: values["enclosure"],
          usage_information: values["usage_information"],
          sanitary_requirements: values["sanitary_requirements"],
          day_avg_using: values["day_avg_using"],

          is_counter: values["is_counter"],
          contains_water: contains_water === undefined ? false : contains_water,
          is_used: is_used === undefined ? false : is_used,
          is_clean: is_clean === undefined ? false : is_clean,
        };
        measurementWellCreate(newList)
      }
      // validation.resetForm();
    },
  });



  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = () => {
    setDeleteModal(true);
  };
  const handleDeletejob = () => {
    if (measurementWell) {
      measurementWellDelete(measurementWell.id);
      setDeleteModal(false);
    }
    setMeasurementWell(null);
    setIs_newCreated(true)
  };
  return (
    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setMeasurementWell(null);
                setContains_waterBoolean(false)
                setIs_usedBoolean(false);
                setIs_cleandBoolean(false)
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

            {
              is_newCreated === false && measurementWell !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementWell?.report_name}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementWell(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэлийн дугаар </Label>
                      <Input
                        name="well_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.well_code || ""}
                        invalid={
                          validation.touched.well_code &&
                            validation.errors.well_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.well_code &&
                        validation.errors.well_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.well_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн зэрэг </Label>
                      <Input
                        name="water_hydraulic_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_hydraulic_quality || ""}
                        invalid={
                          validation.touched.water_hydraulic_quality &&
                            validation.errors.water_hydraulic_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_hydraulic_quality &&
                        validation.errors.water_hydraulic_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_hydraulic_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ажиглалтын хугацааны үр дүн </Label>
                      <Input
                        name="well_counter_detail"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.well_counter_detail || ""}
                        invalid={
                          validation.touched.well_counter_detail &&
                            validation.errors.well_counter_detail
                            ? true
                            : false
                        }
                      />
                      {validation.touched.well_counter_detail &&
                        validation.errors.well_counter_detail ? (
                        <FormFeedback type="invalid">
                          {validation.errors.well_counter_detail}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн судалгааны үе шат </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тоолууртай эсэх </Label>
                      <Input
                        name="is_counter"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.is_counter || ""}
                        invalid={
                          validation.touched.is_counter &&
                            validation.errors.is_counter
                            ? true
                            : false
                        }
                      >
                        <option value="">Тодорхойгүй</option>
                        <option value="false">Байхгүй</option>
                        <option value="true">Байгаа</option>
                      </Input>
                      {validation.touched.is_counter &&
                        validation.errors.is_counter ? (
                        <FormFeedback type="invalid">
                          {validation.errors.is_counter}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын талаарх мэдээлэл </Label>
                      <Input
                        name="depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.depth || ""}
                        invalid={
                          validation.touched.depth &&
                            validation.errors.depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.depth &&
                        validation.errors.depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.depth}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар   </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц тооцсон арга </Label>
                      <Input
                        name="water_stable_level"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_stable_level || ""}
                        invalid={
                          validation.touched.water_stable_level &&
                            validation.errors.water_stable_level
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_stable_level &&
                        validation.errors.water_stable_level ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_stable_level}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц ашиглалт (м<sup>3</sup> хоног) </Label>
                      <Input
                        name="equipment"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.equipment || ""}
                        invalid={
                          validation.touched.equipment &&
                            validation.errors.equipment
                            ? true
                            : false
                        }
                      />
                      {validation.touched.equipment &&
                        validation.errors.equipment ? (
                        <FormFeedback type="invalid">
                          {validation.errors.equipment}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц баялаг (м<sup>3</sup>хоног) </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Устай эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setContains_waterBoolean(!contains_water);
                        }}
                        checked={contains_water}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Судалгааны тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_usedBoolean(!is_used);
                        }}
                        checked={is_used}
                      />
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ордын нийт талбай (км<sup>2</sup>) </Label>
                      <Input
                        name="water_level_decrease"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_level_decrease || ""}
                        invalid={
                          validation.touched.water_level_decrease &&
                            validation.errors.water_level_decrease
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_level_decrease &&
                        validation.errors.water_level_decrease ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_level_decrease}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц тооцсон бүдүүвч схем  </Label>
                      <Input
                        name="refrain"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.refrain || ""}
                        invalid={
                          validation.touched.refrain &&
                            validation.errors.refrain
                            ? true
                            : false
                        }
                      />
                      {validation.touched.refrain &&
                        validation.errors.refrain ? (
                        <FormFeedback type="invalid">
                          {validation.errors.refrain}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны физик шинж чанар </Label>
                      <Input
                        name="enclosure"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.enclosure || ""}
                        invalid={
                          validation.touched.enclosure &&
                            validation.errors.enclosure
                            ? true
                            : false
                        }
                      />
                      {validation.touched.enclosure &&
                        validation.errors.enclosure ? (
                        <FormFeedback type="invalid">
                          {validation.errors.enclosure}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн структур </Label>
                      <Input
                        name="day_avg_using"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.day_avg_using || ""}
                        invalid={
                          validation.touched.day_avg_using &&
                            validation.errors.day_avg_using
                            ? true
                            : false
                        }
                      />
                      {validation.touched.day_avg_using &&
                        validation.errors.day_avg_using ? (
                        <FormFeedback type="invalid">
                          {validation.errors.day_avg_using}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасах эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleandBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр,эрүүл ахуйн шаардлага хангалт </Label>
                      <Input
                        name="water_spurt"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_spurt || ""}
                        invalid={
                          validation.touched.water_spurt &&
                            validation.errors.water_spurt
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_spurt &&
                        validation.errors.water_spurt ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_spurt}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан зохиогчийн нэр  </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default Measurement;